
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground } from 'docz';
import State from '../../../../docs/State';
import DropdownSelect from '@devsisters/ui-careers/lib/DropdownSelect';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>

<MDXTag name="h1" components={components} props={{"id":"dropdownselect"}}>{`DropdownSelect`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-tsx"}}>{`import { DropdownSelect } from '@devsisters/ui/careers';
// 또는 import DropdownSelect from '@devsisters/ui-careers/lib/DropdownSelect';
`}</MDXTag></MDXTag>
<MDXTag name="h3" components={components} props={{"id":"놀이터"}}>{`놀이터`}</MDXTag>
<Playground __position={0} __code={'<h2>단일 항목 선택</h2>\n<State initialState={{ value: null }}>\n  {({ state, setState }) => (\n    <DropdownSelect\n      style={{ width: \'200px\', fontSize: \'16px\' }}\n      placeholder=\"선택해주세요\"\n      items={[\n        { id: \'1\', name: \'딸기\' },\n        { id: \'2\', name: \'바나나\' },\n        { id: \'3\', name: \'스무디\' },\n      ]}\n      value={state.value}\n      onChange={value => setState({ value })}\n    />\n  )}\n</State>\n<h2>복수 항목 선택</h2>\n<State initialState={{ value: [] }}>\n  {({ state, setState }) => (\n    <DropdownSelect\n      style={{ width: \'200px\', fontSize: \'16px\' }}\n      items={[\n        { id: \'1\', name: \'사과\' },\n        { id: \'2\', name: \'포도\' },\n        { id: \'3\', name: \'멜론\' },\n        { id: \'4\', name: \'파인애플\' },\n      ]}\n      multiSelect\n      value={state.value}\n      onChange={value => setState({ value })}\n    />\n  )}\n</State>\n<h2>복수 항목 선택 &amp; placeholder</h2>\n<State initialState={{ value: [] }}>\n  {({ state, setState }) => (\n    <DropdownSelect\n      style={{ width: \'200px\', fontSize: \'16px\' }}\n      placeholder=\"과일\"\n      items={[\n        { id: \'1\', name: \'사과\' },\n        { id: \'2\', name: \'포도\' },\n        { id: \'3\', name: \'멜론\' },\n        { id: \'4\', name: \'파인애플\' },\n      ]}\n      multiSelect\n      value={state.value}\n      onChange={value => setState({ value })}\n    />\n  )}\n</State>\n<h2>복수 항목 선택 &amp; 비어있으면 전부선택으로 간주</h2>\n<State initialState={{ value: [] }}>\n  {({ state, setState }) => (\n    <DropdownSelect\n      style={{ width: \'200px\', fontSize: \'16px\' }}\n      isFilter\n      items={[\n        { id: \'1\', name: \'사과\' },\n        { id: \'2\', name: \'포도\' },\n        { id: \'3\', name: \'멜론\' },\n        { id: \'4\', name: \'파인애플\' },\n      ]}\n      multiSelect\n      value={state.value}\n      onChange={value => setState({ value })}\n    />\n  )}\n</State>\n<h2>복수 항목 선택 &amp; 비어있으면 전부선택으로 간주 &amp; placeholder</h2>\n<State initialState={{ value: [] }}>\n  {({ state, setState }) => (\n    <DropdownSelect\n      style={{ width: \'200px\', fontSize: \'16px\' }}\n      placeholder=\"과일\"\n      isFilter\n      items={[\n        { id: \'1\', name: \'사과\' },\n        { id: \'2\', name: \'포도\' },\n        { id: \'3\', name: \'멜론\' },\n        { id: \'4\', name: \'파인애플\' },\n      ]}\n      multiSelect\n      value={state.value}\n      onChange={value => setState({ value })}\n    />\n  )}\n</State>\n<h2>스크롤</h2>\n<State initialState={{ value: null }}>\n  {({ state, setState }) => (\n    <DropdownSelect\n      style={{ width: \'200px\', fontSize: \'16px\' }}\n      placeholder=\"선택해주세요\"\n      items={[\n        { id: \'1\', name: \'딸기\' },\n        { id: \'2\', name: \'바나나\' },\n        { id: \'3\', name: \'스무디\' },\n        { id: \'4\', name: \'드랍\' },\n        { id: \'5\', name: \'다운\' },\n        { id: \'6\', name: \'셀렉트\' },\n      ]}\n      value={state.value}\n      onChange={value => setState({ value })}\n    />\n  )}\n</State>\n<h2>기다란 내용</h2>\n<State initialState={{ value: null }}>\n  {({ state, setState }) => (\n    <DropdownSelect\n      style={{ width: \'200px\', fontSize: \'16px\' }}\n      placeholder=\"선택해주세요\"\n      items={[\n        { id: \'1\', name: \'딸기\' },\n        { id: \'2\', name: \'바나나\' },\n        { id: \'3\', name: \'스무디\' },\n        { id: \'4\', name: \'기다란 내용이 들어있으면 어떻게 보일까요\' },\n      ]}\n      value={state.value}\n      onChange={value => setState({ value })}\n    />\n  )}\n</State>\n<h2>기다란 내용 2</h2>\n<State initialState={{ value: null }}>\n  {({ state, setState }) => (\n    <DropdownSelect\n      style={{ minWidth: \'200px\', fontSize: \'16px\' }}\n      placeholder=\"선택해주세요\"\n      items={[\n        { id: \'1\', name: \'딸기\' },\n        { id: \'2\', name: \'바나나\' },\n        { id: \'3\', name: \'스무디\' },\n        { id: \'4\', name: \'기다란 내용이 들어있으면 어떻게 보일까요\' },\n      ]}\n      value={state.value}\n      onChange={value => setState({ value })}\n    />\n  )}\n</State>\n<h2>에러</h2>\n<State initialState={{ value: null }}>\n  {({ state, setState }) => (\n    <DropdownSelect\n      style={{ marginBottom: \'250px\', width: \'200px\', fontSize: \'16px\' }}\n      placeholder=\"선택해주세요\"\n      items={[\n        { id: \'1\', name: \'딸기\' },\n        { id: \'2\', name: \'바나나\' },\n        { id: \'3\', name: \'스무디\' },\n      ]}\n      value={state.value}\n      error\n      onChange={value => setState({ value })}\n    />\n  )}\n</State>'} __scope={{props: this ? this.props : props,State,DropdownSelect}}>
  <h2>단일 항목 선택</h2>
  <State initialState={{ value: null }}>
    {({ state, setState }) => (
      <DropdownSelect
        style={{ width: '200px', fontSize: '16px' }}
        placeholder='선택해주세요'
        items={[
          { id: '1', name: '딸기' },
          { id: '2', name: '바나나' },
          { id: '3', name: '스무디' },
        ]}
        value={state.value}
        onChange={value => setState({ value })}
      />
    )}
  </State>
  <h2>복수 항목 선택</h2>
  <State initialState={{ value: [] }}>
    {({ state, setState }) => (
      <DropdownSelect
        style={{ width: '200px', fontSize: '16px' }}
        items={[
          { id: '1', name: '사과' },
          { id: '2', name: '포도' },
          { id: '3', name: '멜론' },
          { id: '4', name: '파인애플' },
        ]}
        multiSelect
        value={state.value}
        onChange={value => setState({ value })}
      />
    )}
  </State>
  <h2>복수 항목 선택 &amp; placeholder</h2>
  <State initialState={{ value: [] }}>
    {({ state, setState }) => (
      <DropdownSelect
        style={{ width: '200px', fontSize: '16px' }}
        placeholder='과일'
        items={[
          { id: '1', name: '사과' },
          { id: '2', name: '포도' },
          { id: '3', name: '멜론' },
          { id: '4', name: '파인애플' },
        ]}
        multiSelect
        value={state.value}
        onChange={value => setState({ value })}
      />
    )}
  </State>
  <h2>복수 항목 선택 &amp; 비어있으면 전부선택으로 간주</h2>
  <State initialState={{ value: [] }}>
    {({ state, setState }) => (
      <DropdownSelect
        style={{ width: '200px', fontSize: '16px' }}
        isFilter
        items={[
          { id: '1', name: '사과' },
          { id: '2', name: '포도' },
          { id: '3', name: '멜론' },
          { id: '4', name: '파인애플' },
        ]}
        multiSelect
        value={state.value}
        onChange={value => setState({ value })}
      />
    )}
  </State>
  <h2>복수 항목 선택 &amp; 비어있으면 전부선택으로 간주 &amp; placeholder</h2>
  <State initialState={{ value: [] }}>
    {({ state, setState }) => (
      <DropdownSelect
        style={{ width: '200px', fontSize: '16px' }}
        placeholder='과일'
        isFilter
        items={[
          { id: '1', name: '사과' },
          { id: '2', name: '포도' },
          { id: '3', name: '멜론' },
          { id: '4', name: '파인애플' },
        ]}
        multiSelect
        value={state.value}
        onChange={value => setState({ value })}
      />
    )}
  </State>
  <h2>스크롤</h2>
  <State initialState={{ value: null }}>
    {({ state, setState }) => (
      <DropdownSelect
        style={{ width: '200px', fontSize: '16px' }}
        placeholder='선택해주세요'
        items={[
          { id: '1', name: '딸기' },
          { id: '2', name: '바나나' },
          { id: '3', name: '스무디' },
          { id: '4', name: '드랍' },
          { id: '5', name: '다운' },
          { id: '6', name: '셀렉트' },
        ]}
        value={state.value}
        onChange={value => setState({ value })}
      />
    )}
  </State>
  <h2>기다란 내용</h2>
  <State initialState={{ value: null }}>
    {({ state, setState }) => (
      <DropdownSelect
        style={{ width: '200px', fontSize: '16px' }}
        placeholder='선택해주세요'
        items={[
          { id: '1', name: '딸기' },
          { id: '2', name: '바나나' },
          { id: '3', name: '스무디' },
          { id: '4', name: '기다란 내용이 들어있으면 어떻게 보일까요' },
        ]}
        value={state.value}
        onChange={value => setState({ value })}
      />
    )}
  </State>
  <h2>기다란 내용 2</h2>
  <State initialState={{ value: null }}>
    {({ state, setState }) => (
      <DropdownSelect
        style={{ minWidth: '200px', fontSize: '16px' }}
        placeholder='선택해주세요'
        items={[
          { id: '1', name: '딸기' },
          { id: '2', name: '바나나' },
          { id: '3', name: '스무디' },
          { id: '4', name: '기다란 내용이 들어있으면 어떻게 보일까요' },
        ]}
        value={state.value}
        onChange={value => setState({ value })}
      />
    )}
  </State>
  <h2>에러</h2>
  <State initialState={{ value: null }}>
    {({ state, setState }) => (
      <DropdownSelect
        style={{ marginBottom: '250px', width: '200px', fontSize: '16px' }}
        placeholder='선택해주세요'
        items={[
          { id: '1', name: '딸기' },
          { id: '2', name: '바나나' },
          { id: '3', name: '스무디' },
        ]}
        value={state.value}
        error
        onChange={value => setState({ value })}
      />
    )}
  </State>
</Playground>
           </MDXTag>
  }
}
  